import { useEffect, useRef, useState } from 'react';
import SubmitAndCancelButton from '../../../components/button/SubmitAndCancelButton';
import { format as dfFormat, format } from 'date-fns';
import YmdPicker from '../../../components/picker/YmdPicker';
import 'react-datepicker/dist/react-datepicker.css';
import Input from '../../../components/inputs/Input';
import { CostPutRequest } from '../../../types/cost/CostPutRequest';
import { CategoryArray } from '../../../types/cost/CostGetResponse';
import { focusNextInput } from '../../../utils/focusNextInput';

interface EditCostRowProps {
  item: CostPutRequest;
  categories: CategoryArray[];
  onChange: (key: keyof CostPutRequest, value: any) => void;
  onEditSubmitButtonClick: (id: number) => void;
  onEditCancelButtonClick: () => void;
}

const EditCostRow: React.FC<EditCostRowProps> = ({
  item,
  categories,
  onChange,
  onEditSubmitButtonClick,
  onEditCancelButtonClick,
}) => {
  const inputsRef = useRef<
    (HTMLInputElement | HTMLSelectElement | HTMLButtonElement)[]
  >([]);

  // 最初の input に自動フォーカス
  useEffect(() => {
    if (inputsRef.current[0]) {
      inputsRef.current[0].focus();
    }
  }, []);

  return (
    <>
      <td>
        <select
          value={item.costCategoryId}
          onChange={(e) => onChange('costCategoryId', Number(e.target.value))}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el))
              inputsRef.current.push(el);
          }}
          onKeyDown={(e: any) => focusNextInput(e, inputsRef as any, 0)}
          className="form-select"
        >
          {/* プレースホルダ（任意） */}
          <option value={0} disabled>
            選択してください
          </option>
          {categories.map((c) => (
            <option key={c.id} value={c.id}>
              {c.category}
            </option>
          ))}
        </select>
      </td>
      <td>
        <Input
          value={item.detail}
          onChange={(e) => onChange('detail', e.target.value)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef as any, 1)}
        />
      </td>
      <td>
        <YmdPicker
          selectedDate={new Date(item.date)}
          setSelectedDate={(date) =>
            onChange('date', date ? format(date, 'yyyy-MM-dd') : '')
          }
          placeholder="年/月/日"
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef as any, 2)}
        />
      </td>
      <td>
        <Input
          value={String(item.price)}
          onChange={(e) => onChange('price', e.target.value)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef as any, 3)}
        />
      </td>
      <td className="text-center">
        <SubmitAndCancelButton
          onSubmit={() => onEditSubmitButtonClick(item.id)}
          onCancel={() => onEditCancelButtonClick()}
          onSubmitKeyDown={(e) => focusNextInput(e, inputsRef as any, 4)}
          onCancelKeyDown={(e) => focusNextInput(e, inputsRef as any, 5)}
          submitButtonRef={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          cancelButtonRef={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
        />
      </td>
    </>
  );
};

export default EditCostRow;
